<template>
  <v-layout>
    <v-flex>
      <div class="text-right mb-6">
        <v-btn
          class="ml-md-10"
          dark
          large
          depressed
          color="primary"
          :to="{ name:'warehouse', params: { id: 'add' } }"
        >
          <v-icon dark class="mr-2">
            mdi-plus
          </v-icon>
          <span class="mx-4">Create New Warehouse</span>
        </v-btn>
      </div>
      <v-card class="pa-6 pt-4 mt-10">
        <v-card-title>
          Warehouses
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            class="table-search"
            hide-details>
          </v-text-field>
        </v-card-title>

        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="warehouses"
          :server-items-length="pagination.total"
          :items-per-page="pagination.per_page"
          :footer-props="{ itemsPerPageOptions: [10, 20, 30] }"
          :loading="loading"
          loading-text="Loading Warehouse..."
          item-key="id"
          no-data-text="No Warehouse Found"
          :options.sync="options"
          ref="table">

          <template v-slot:[`item.created_at`]="{ item }">
            {{ item.created_at | moment("MMM D, YYYY h:mm A") }}
          </template>

          <template v-slot:[`item.updated_at`]="{ item }">
            {{ item.updated_at | moment("MMM D, YYYY h:mm A") }}
          </template>

          <template v-slot:item.action="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  class="mr-2"
                  color="primary"
                  @click="editItem(item.id)">
                  mdi-pencil
                </v-icon>
              </template>
              <span>Edit</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  color="red darken-2"
                  @click="deleteItem(item)">
                  mdi-delete
                </v-icon>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>




      <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
      <ConfirmationDialog
        :dialog="dialog"
        @doConfirm="doConfirm"
        @doCancel="doCancel"
      >
      </ConfirmationDialog>

    </v-flex>
  </v-layout>

</template>




<script>
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import ConfirmationDialog from '@/components/dialog/ConfirmationDialog.vue'

  export default {
    name: 'warehouses',
    data() {
      return {
        adminNamespace: 'admin',
        dialog: {
          show: false,
          title: 'Delete Item',
          body: 'Are you sure you want to delete this item?',
          type: '',
          item: {},
          confirmBtn: 'Yes',
          cancelBtn: 'Cancel'
        },
        snackbarDetails: {
          color: 'sb-success',
          msg: '',
          show: false
        },
        error:{
          show: false,
          status: '',
          error: '',
          messages: {}
        },
        firstLoad: true,
        loading: false,
        search: '',
        awaitingSearch: false,
        selected: [],
        warehouses: [],
        pagination: {
          page: 1,
          per_page: 1,
          total: 0,
          next: 0
        },
        options: {},
        headers: [
          {
            text: 'Code',
            align: 'start',
            value: 'code',
            sortable: false,
            width: 200
          },
          {
            text: 'Name',
            align: 'start',
            value: 'name',
            sortable: false
          },
          {
            text: 'Created At',
            align: 'start',
            value: 'created_at',
            sortable: false,
            width: 180
          },
          {
            text: 'Updated At',
            align: 'start',
            value: 'updated_at',
            sortable: false,
            width: 180
          },
          {
            text: 'Action',
            value: 'action',
            align: 'center',
            sortable: false,
            width: 100
          }
        ]
      }
    },
    computed: {
      hasSelected: function(){
        return this.selected.length != 0 ? false : true
      }
    },
    watch: {
      options: {
        handler () {
          this.getWarehouses()
        },
        deep: true,
      },
      search: function (val) {
        if (!this.awaitingSearch) {
          setTimeout(() => {
            this.options.page = 1
            this.getWarehouses()
            this.awaitingSearch = false;
          }, 1000); // 1 sec delay
        }
        this.awaitingSearch = true;
      },
    },
    methods: {
      doConfirm () {
        this.dialog.show = false
        this.confirmDeleteItem()
      },
      doCancel () {
        this.dialog.show = false
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
      editItem (id) {
        this.$router.push({ name: 'warehouse', params: { id: id } })
      },
      deleteItem (item) {
        this.dialog = {
         show: true,
         title: 'Delete Warehouse',
         body: 'Are you sure you want to delete '+item.name+' warehouse?',
         type: 'close',
         item: item,
         confirmBtn: 'Yes',
         cancelBtn: 'No'
        }
      },
      confirmDeleteItem () {
        let self = this

        this.$http.secured.delete(this.adminNamespace+'/warehouses/'+ this.dialog.item.id)
          .then(response => {
            if(response.data){

              this.showMessage(this.dialog.item.name + " has been successfully deleted", 'success')

              if(this.options.page > 1) {
                  this.options.page = 1
                  return false
              }

              this.getWarehouses()

            }
          })
          .catch(error => {
            if (error.response) {
              this.showMessage(error.response.data.error, 'error')
              this.error.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
            self.dialog.show = false
          })

      },
      getWarehouses () {
        if (this.loading) {
          return false
        }

        const { sortBy, sortDesc, page, itemsPerPage } = this.options
        let sorting = []
        let params = []

        if (sortBy.length === 1 && sortDesc.length === 1) {
          sortBy.forEach(function (item, index) {
            let sort = 'ASC'
            if (!sortDesc[index]) {
              sort = 'DESC'
            }
            sorting.push(item+'='+sort)
          });
        }

        if (this.search.length > 0){
          params.push('&search='+this.search)
        }

        if(!this.firstLoad){
          this.$router.push({ name: 'warehouses-page', params: { page: page }})
        }

        this.firstLoad = false

        this.loading = true
        let self = this
        this.$http.plain.get(this.adminNamespace+'/warehouses?page='+ page + '&per_page=' + itemsPerPage + params.join())
          .then(response => {
            this.warehouses = response.data.warehouses

            if (response.data.pagination) {
              let pagination = response.data.pagination

              this.pagination.total = pagination.count
            }

          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
            self.loading = false
          })
        }
    },
    mounted() {

      if(this.$route.query.added){
        this.showMessage(this.$route.query.message, 'success')
        this.$router.push({ name: 'warehouses' })
      }

      if(this.$route.params.page){
        this.options.page = parseInt(this.$route.params.page)
      }

    },
    components: {
      SnackBar,
      ConfirmationDialog
    },
  }
</script>
